export const config = {
    entityKey: 'domainNames',
    titles: {
        singular: 'Domain Name',
        plural: 'Domain Names'
    },
}